module.exports = __webpack_public_path__ + "static/media/sample_avatar.ccffe047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/sample_avatar.jpg
// module id = 1933
// module chunks = 1